/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Boats_DescInputs */

const es_nav_m_boats_desc = /** @type {(inputs: Nav_M_Boats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora barcos en alquiler`)
};

const gl_nav_m_boats_desc = /** @type {(inputs: Nav_M_Boats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora barcos en alugueiro`)
};

const en_nav_m_boats_desc = /** @type {(inputs: Nav_M_Boats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse boats for rent`)
};

/**
* | output |
* | --- |
* | "Browse boats for rent" |
*
* @param {Nav_M_Boats_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_boats_desc = /** @type {((inputs?: Nav_M_Boats_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Boats_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_boats_desc(inputs)
	if (locale === "en") return en_nav_m_boats_desc(inputs)
	return es_nav_m_boats_desc(inputs)
});